export function formatToJSON(text) {
  return JSON.parse(text);
}
